module.exports = __webpack_public_path__ + "img/sh.b55f7409.png";